var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form Elements/Checkbox/Medium/Icon/Fully Rounded/Checked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#064765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92726 3.47403C9.01696 3.38002 9.12012 3.33301 9.23674 3.33301C9.35335 3.33301 9.45651 3.38002 9.54622 3.47403C9.62695 3.55865 9.66732 3.66442 9.66732 3.79134C9.66732 3.91826 9.62695 4.02403 9.54622 4.10865L5.25386 8.63557C5.24489 8.64497 5.23592 8.65437 5.22695 8.66378C5.21798 8.67318 5.20901 8.68258 5.20004 8.69198C5.11931 8.786 5.01839 8.83301 4.89729 8.83301C4.77619 8.83301 4.67527 8.786 4.59453 8.69198L2.45509 6.46378C2.37435 6.37916 2.33398 6.27339 2.33398 6.14647C2.33398 6.01955 2.37435 5.91378 2.45509 5.82916C2.54479 5.73514 2.64795 5.68814 2.76457 5.68814C2.88118 5.68814 2.98434 5.73514 3.07405 5.82916L4.89056 7.73301L8.92726 3.47403Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRound);
export default __webpack_public_path__ + "static/media/Checked_round.ec514225a9544de07aefbb7dbca6bec7.svg";
export { ForwardRef as ReactComponent };